import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoMessagesGetRes } from "./abst/DtoMessagesGetRes";

export class DtoMessagesGetResImple extends DtoMessagesGetRes {
  public pager = new DtoApiPager();
}
